import { render, staticRenderFns } from "./myPaper.vue?vue&type=template&id=3f6422fa&scoped=true&"
import script from "./myPaper.vue?vue&type=script&lang=js&"
export * from "./myPaper.vue?vue&type=script&lang=js&"
import style0 from "./myPaper.vue?vue&type=style&index=0&id=3f6422fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6422fa",
  null
  
)

export default component.exports